import {
    URLAPI,
    NOVELTY_PATH,
    NOVELTY_CREATE_PATH,
    NOVELTY_REPORT_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_novelty: {
        data: [],

        status: 0,
        message: {},
    },
    _create_novelty: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_NOVELTY = "GET_ALL_NOVELTY";
export const CREATE_NOVELTY = "CREATE_NOVELTY";
export const GET_REPORT = "GET_REPORT";

export const novelty_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_NOVELTY:
            return {
                ...state,
                _get_all_novelty: action.payload,
            };
        case CREATE_NOVELTY:
            return {
                ...state,
                _create_novelty: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllNovelty = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${NOVELTY_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_NOVELTY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_NOVELTY,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_NOVELTY,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create novelty
export const createNovelty = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${NOVELTY_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_NOVELTY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_NOVELTY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_NOVELTY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + NOVELTY_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_novelty = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
